module.exports = __webpack_public_path__ + "static/media/send-icon.9d3dca18.svg";